/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseText from 'app/components/common/BaseText'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { convertColumnTable } from 'app/components/tables/BaseTableReport/hook'
import { useMemo, useState } from 'react'
import { IActivityEvent, ILocation } from '../../../CreateEvent/type'
import { PermissionEnum } from 'app/common/enum'
import { BasePopover } from 'app/components/common/BasePopover'
import { BaseButton } from 'app/components/common/BaseButton'
import { DeleteOutlined, MoreOutlined } from '@ant-design/icons'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { ModalUpdateLocation } from '../../modal/location'
import { useVerifyPermission } from 'app/helpers/permission.helper'
import { requestDeleteLocationActivity } from 'app/api/location'
import { notificationController } from 'app/controllers/notification-controller'
import { BasePopconfirm } from 'app/components/common/BasePopconfirm'

export const LocationLayout = ({ activity }: { activity?: IActivityEvent }) => {
  const data = useMemo(() => {
    return activity?.locations?.map((item, index) => {
      return {
        ...item,
        key: index,
      }
    })
  }, [activity?.locations])

  const { verifyPermission } = useVerifyPermission()

  const [loadingDelete, setLoadingDelete] = useState(false)
  const onPressDeleteLocation = async (id?: number) => {
    if (!id) return
    try {
      setLoadingDelete(true)
      const res = await requestDeleteLocationActivity(id)
      if (res) {
        notificationController.success({ message: 'Thành công!' })
        window.location.reload()
      }
    } catch (error) {
      console.log({ error })
    } finally {
      setLoadingDelete(false)
    }
  }

  return (
    <BaseTableManagement
      dataSource={data}
      columns={[
        convertColumnTable<ILocation & { key: number }>({
          key: 'key',
          title: 'STT',
          fixed: 'left',
          classNameWidthColumnOverwrite: 'number-column',
          render: (index: number) => {
            return (
              <BaseText
                children={index + 1}
                fontWeight="medium"
                opacity="0.7"
              />
            )
          },
        }),
        convertColumnTable<ILocation>({
          key: 'address',
          title: 'Địa chỉ',
          fixed: 'left',
          classNameWidthColumnOverwrite: 'big-column',
          render: (text?: string) => {
            return <BaseText children={text} fontWeight="medium" />
          },
        }),
        convertColumnTable<ILocation>({
          key: 'key_map_check_in',
          title: 'Toạ độ',
          render: (_, record) => {
            return (
              <BaseText
                children={`${record?.lat}, ${record?.long}`}
                fontWeight="medium"
                opacity="0.7"
              />
            )
          },
        }),

        convertColumnTable<ILocation>({
          key: 'radius',
          title: 'Bán kính (m)',
          render: (text?: string) => {
            return (
              <BaseText children={text} fontWeight="medium" opacity="0.7" />
            )
          },
        }),

        ...(verifyPermission(PermissionEnum.UpdateEvent)
          ? [
              convertColumnTable<any>({
                key: 'key',
                title: '',
                fixed: 'right',
                classNameWidthColumnOverwrite: 'number-column',
                render: (_, record) => {
                  return (
                    <BasePopover
                      trigger={'click'}
                      content={
                        <BaseSpace size={8}>
                          <ModalUpdateLocation location={record} />
                          <BasePopconfirm
                            trigger={'click'}
                            title={'Bạn có thực sự muốn xoá?'}
                            onConfirm={() => onPressDeleteLocation(record?.id)}
                          >
                            <BaseButton
                              type="text"
                              icon={
                                <DeleteOutlined
                                  style={{ color: 'red' }}
                                  rev={undefined}
                                />
                              }
                              loading={loadingDelete}
                              style={{
                                width: '100%',
                                justifyContent: 'flex-start',
                              }}
                            >
                              {'Xoá'}
                            </BaseButton>
                          </BasePopconfirm>
                        </BaseSpace>
                      }
                    >
                      <BaseButton
                        icon={<MoreOutlined rev={undefined} />}
                        type="text"
                      />
                    </BasePopover>
                  )
                },
              }),
            ]
          : []),
      ]}
      scroll={{ x: true }}
      pagination={{
        pageSize: 5,
      }}
      className="row-overwrite-style"
    />
  )
}
